import {useEffect} from 'react';

import {useContentDiscoveryStore} from '../ContentDiscoveryStore.react';

export const useDraftSubscription = () => {
  useEffect(() => {
    const {draft} = useContentDiscoveryStore.getState();

    const unsubscribers = [
      useContentDiscoveryStore.subscribe(
        (state) => state.assignment.assignment,
        (initialAssignment) => {
          if (initialAssignment && !draft.draftName) {
            draft.setDraftName(initialAssignment.getName());
          } else if (draft.draftName) {
            draft.setDraftName(draft.draftName);
          }
        }
      )
    ];

    return () => {
      unsubscribers.forEach((unsub) => unsub());
    };
  }, []);
};
